module.exports = __webpack_public_path__ + "static/img/logoimage.7e65de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoimage.png
// module id = rEiP
// module chunks = 0